var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.classList,attrs:{"disabled":_vm.disabled,"type":_vm.type}},_vm.$listeners),[(_vm.loading)?_c('m-loading',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }